import { render } from "./MainLayout2.vue?vue&type=template&id=96b676d4"
import script from "./MainLayout2.vue?vue&type=script&lang=js"
export * from "./MainLayout2.vue?vue&type=script&lang=js"

import "./MainLayout2.vue?vue&type=style&index=0&id=96b676d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__